export const isVisible = (el, offset) => {
  const rectInView = el.getBoundingClientRect()

  const hitbox_top = window.innerHeight
  const element_top = rectInView.top - offset
  const element_bottom = rectInView.top + window.innerHeight

  return hitbox_top < element_bottom + 0 && hitbox_top > element_top - 0
}
